module.exports = __webpack_public_path__ + "img/banner-03z.a9206dc3.png";